import React from 'react';
import axios from 'axios';

import * as Globals from './../Globals';


export default class ResultQuestion extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            answers: [],
            checkedAnswers: []
        }
    }

    componentDidMount() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + "question/" + this.props.questionID + "/answer?Authentication=" + cookie
        ).then(response => {
            let answers = response.data.records;
            axios.get(Globals.EL_PATH + "testresult_question/" + this.props.id + "/testresult_answer?Authentication=" + cookie
            ).then(response => {
                this.setState({
                    answers: answers,
                    checkedAnswers: response.data.records
                });
            }).catch(error => {
                this.props.CheckAuthError(error);
            });
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
    }

    getCheckedAnswer(answer, index) {
        if (index >= this.state.checkedAnswers.length) return "N/A bzw. Änderung der antworten";
        if (this.state.checkedAnswers[index].answered_correctly) return answer.IS_TRUE ? "Ja" : "Nein";
        return answer.IS_TRUE ? "Nein" : "Ja";
    }

    render() {
        return (
            <div className={(this.props.isRight) ? "panel panel-success" : "panel panel-danger"}>
                <div className="panel-heading text-center"><h4 style={{"margin": "0"}}>{this.props.text}</h4>
                </div>
                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th>Antwort</th>
                            <th>Anzukreuzen</th>
                            <th>Angekreuzt</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.answers.map((answer, index) =>
                                <tr key={index}>
                                    <td>{answer.TEXT}</td>
                                    <td>{(answer.IS_TRUE) ? "Ja" : "Nein"}</td>
                                    <td> {this.getCheckedAnswer(answer, index)} </td>
                                </tr>)
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/admin/ResultQuestion.js